import { render, staticRenderFns } from "./Breaker.vue?vue&type=template&id=88b38812"
import script from "./Breaker.vue?vue&type=script&lang=ts"
export * from "./Breaker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports